import React, { Component } from "react";
import PropTypes from "prop-types";
import api from "APP_ROOT/api";
import { Map } from "immutable";
import { Field, formValueSelector, Fields, change } from "redux-form";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { properCase } from "LIB/formatters/text";
import {
  BUYER_CREDIT_PCT,
  ID,
  MINIMUM_EXCHANGE_SRP,
  QUANTITY,
  RESERVE_FOR_SELLER_ID,
  SETTINGS
} from "APP_ROOT/constants";
import * as actions from "MODULES/inventories/actions";
import * as partsActions from "MODULES/parts/actions";
import * as poActions from "MODULES/PurchaseOrders/actions";
import { BuyerField } from "MODULES/PurchaseOrders/shared";
import {
  CONDITION,
  EXCHANGE_SRP,
  FREIGHT_COMPLETE,
  FINAL_FREIGHT_CONFIRMED,
  INSPECTED,
  INVENTORIES,
  OVERHAULED,
  REPAIRED,
  SERIAL_NUMBER,
  SRP_CONDITION,
  STORE_OWNER,
  SUGGESTED_RETAIL,
  TAG_DATE,
  TAGGED_BY,
  TRACED_TO,
  TRACE_TYPE,
  WARRANTY_OVERRIDE,
  PART_ID,
  STORE_LOCATION,
  LOCATION,
  REPAIR_AND_HOLD,
  AS_REMOVED,
  NEW_ITEM,
  FAA,
  EASA,
  CAAC,
  TCCA,
  UK_CAA,
  EXPIRATION,
  STORE_LOCATION_ID,
  STORE_OWNER_ID,
  OTHER,
  OTHER_TAG_TYPE,
  IMPERFECT_TRACE_REASONS,
  WARRANTY_OPTIONS,
  WAREHOUSE,
  LISTING_OVERRIDE,
  UNSELLABLE_PER_USER,
  DO_NOT_SELL_REASON,
  DO_NOT_SELL_REASON_OPTIONS,
  STATUS,
  GONE,
  TOTAL_HOURS_REMAINING,
  TOTAL_CYCLES_REMAINING,
  AIRCRAFT_REFERENCE_NUMBER,
  AIRCRAFT_TAIL_NUMBER
} from "MODULES/inventories/constants";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import {
  ACCOUNTING,
  ADMIN,
  BUYER,
  QUALITY_CONTROL,
  REPAIR,
  SALES,
  QUALITY_CONTROL_ADMIN,
  QUALITY_CONTROL_MANAGER,
  WAREHOUSE_EXPERT,
  USER,
  BUYER_ID,
  CO_BUYER_ID,
  THIRD_BUYER_ID,
  WAREHOUSE_MANAGER,
  WAREHOUSE_LOGISTICS_DIRECTOR,
  CAN_OVERRIDE_LISTING,
  ROLE,
  CAN_EDIT_DO_NOT_EXCHANGE
} from "MODULES/users/constants";
import { arrayToOptions, toOptions } from "LIB/forms";
import {
  form,
  Form as AppForm,
  AutoCompleteField,
  AutoCompleteUserInputField,
  CurrencyField,
  Check,
  CheckGroup,
  FormInput,
  Select,
  NumberInput
} from "MODULES/shared/components/Forms";
import { Authorized } from "MODULES/shared/components";
import BuyingStoreField from "MODULES/PurchaseOrders/shared/BuyerStoreField";
import MonthYearField from "MODULES/shared/components/Forms/MonthYearField/MonthYearField";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";
import {
  ACTIVE,
  CREDIT_HOLD,
  DO_NOT_EXCHANGE,
  IMPERFECT_TRACE,
  IMPERFECT_TRACE_REASON
} from "MODULES/companies/constants";
import {
  CONSIGNMENT_REFERENCE,
  CONSIGNOR_PERCENTAGE
} from "MODULES/Receiving/constants";
import BuyingStoreRadioField from "MODULES/Locations/components/BuyingStoreRadioField";
import {
  disableIfHasAnyOfRoles,
  hasAnyOfRoles,
  hasAnyOfSubroles,
  hasPermission,
  hasRole,
  hasSubRole
} from "MODULES/users/helpers";
import { PART, TOTAL_CYCLES, TOTAL_HOURS } from "MODULES/parts/constants";
import {
  BUYER_CREDIT_PCT_OPTIONS,
  INCIDENT
} from "MODULES/PurchaseOrders/constants";
import CoBuyersFields from "MODULES/PurchaseOrders/shared/CoBuyersFields/CoBuyersFields";
import {
  totalCyclesRemaining,
  totalHoursRemaining
} from "MODULES/inventories/helpers";
import TierTypeExchangeSrpWarning from "MODULES/PurchaseOrders/shared/TierTypeExchangeSrpWarning";
import _, { isEmpty } from "lodash";
import ConditionWarning from "./ConditionWarning";
import validate from "./validate";
import TagTypes from "./TagTypes";
import FormRow from "../../../shared/components/Forms/FormRow";
import { PreviousSrpConditionWarning } from "../../../PurchaseOrders/shared/PreviousSrpConditionWarning";

const FORM_NAME = "editPart";

export class Form extends Component {
  state = {
    selectedPart: {},
    selectedBuyer: {},
    selectedCoBuyer: {},
    selectedThirdBuyer: {},
    selectedInventory: {},
    passFailWarning: false
  };

  componentWillMount() {
    if (this.props.inventory) {
      const inv = this.props.inventory.toJS();
      this.setState({
        selectedBuyer: inv.buyer,
        selectedCoBuyer: inv.co_buyer,
        selectedThirdBuyer: inv.third_buyer,
        selectedInventory: inv,
        selectedPart: inv.part,
        selectedRepairStatus: inv.repair_status
      });
    }
  }

  handlePartSelected = part => {
    this.setState({ selectedPart: part });
  };

  handlePassFailWarning = () => {
    this.setState({ passFailWarning: !this.state.passFailWarning });
  };

  searchCompanies = filter => {
    if (
      filter &&
      filter.match("N/A") &&
      [AS_REMOVED, NEW_ITEM].includes(this.props.getField(CONDITION))
    ) {
      return Promise.resolve([{ name: "N/A" }]);
    }
    return api.companies
      .search({
        filter,
        status: [ACTIVE, CREDIT_HOLD].join(","),
        page: 1,
        limit: 20
      })
      .then(resp => resp.data.results);
  };

  render() {
    const {
      currentUser,
      getField,
      searchParts,
      inventory,
      quantity,
      condition,
      lockInventory,
      searchBuyers,
      setField
    } = this.props;

    const {
      selectedBuyer,
      selectedCoBuyer,
      selectedThirdBuyer,
      selectedInventory,
      selectedPart,
      selectedRepairStatus
    } = this.state;

    const isNonBasicWarehouseUser =
      hasRole(currentUser, WAREHOUSE) &&
      hasAnyOfSubroles(currentUser, [
        WAREHOUSE_EXPERT,
        WAREHOUSE_MANAGER,
        WAREHOUSE_LOGISTICS_DIRECTOR
      ]);

    const isAdminUser = currentUser.role === ADMIN;
    const isRepairUser = hasRole(currentUser, REPAIR);
    const isQCUser = hasRole(currentUser, QUALITY_CONTROL);
    const isAccountingUser = hasRole(currentUser, ACCOUNTING);
    const isLLP = selectedPart && selectedPart.llp;

    const canEditFreightComplete = hasAnyOfRoles(currentUser, [
      ACCOUNTING,
      QUALITY_CONTROL
    ]);

    const canOverrideListing = hasPermission(currentUser, CAN_OVERRIDE_LISTING);

    const canReidentifySerial = hasAnyOfSubroles(currentUser, [
      QUALITY_CONTROL_MANAGER,
      QUALITY_CONTROL_ADMIN
    ]);

    const disableFields =
      lockInventory &&
      !hasAnyOfRoles(currentUser, [QUALITY_CONTROL, REPAIR]) &&
      !hasSubRole(currentUser, WAREHOUSE_EXPERT) &&
      currentUser.role !== ADMIN;

    const canEditTraceAndTagFields =
      hasAnyOfRoles(currentUser, [QUALITY_CONTROL, REPAIR]) ||
      hasAnyOfSubroles(currentUser, [
        WAREHOUSE_MANAGER,
        WAREHOUSE_LOGISTICS_DIRECTOR,
        WAREHOUSE_EXPERT
      ]);

    const canEditFlags =
      isAdminUser || isNonBasicWarehouseUser || isRepairUser || isQCUser;

    const toggleBuyer = buyer => this.setState(buyer);

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <Row>
            <Col md={6}>
              <Field
                name={PART_ID}
                label="Part #"
                placeholder="Type a part's number..."
                component={AutoCompleteField}
                search={searchParts}
                selectedItem={selectedPart}
                formatItem={result => result && result.part_number}
                onItemSelected={i => i && this.handlePartSelected(i)}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                required
              />
            </Col>
            <Col md={6}>
              <Field
                name={SERIAL_NUMBER}
                component={FormInput}
                label="Serial #"
                required={quantity > 1}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
              />
            </Col>
          </Row>
          <FormRow>
            <Col md={4}>
              <BuyingStoreRadioField
                label={properCase(STORE_OWNER)}
                name={STORE_OWNER_ID}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isAccountingUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                required
              />
            </Col>
            <Col md={4}>
              <BuyingStoreRadioField
                name={STORE_LOCATION_ID}
                label={properCase(STORE_LOCATION)}
                component={BuyingStoreField}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isAccountingUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                required
              />
            </Col>
            <Col md={2}>
              <Field
                component={FormInput}
                name={LOCATION}
                label={properCase(LOCATION)}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                required
              />
            </Col>
            {_.size(_.get(currentUser, "tenant.ware_houses")) > 0 && (
              <Col md={2}>
                <Field
                  name={"ware_house_id"}
                  component={Select}
                  options={_.get(
                    currentUser,
                    "tenant.ware_houses",
                    []
                  ).map(wareHouse => ({
                    value: wareHouse.id,
                    text: wareHouse.name
                  }))}
                  label={properCase(WAREHOUSE)}
                  disabled={
                    disableFields ||
                    (!isAdminUser &&
                      !isNonBasicWarehouseUser &&
                      !isRepairUser &&
                      !isQCUser)
                  }
                />
              </Col>
            )}
          </FormRow>
          <Authorized
            authorizedIf={user =>
              user.get(ROLE) === ADMIN && inventory.get(STATUS) !== GONE}
          >
            <React.Fragment>
              <hr className="hr-xs hr-dashed" />
              <Row>
                <Col md={3}>
                  <Field
                    name={BUYER_CREDIT_PCT}
                    className="text-right"
                    component={Select}
                    options={BUYER_CREDIT_PCT_OPTIONS}
                    onChange={(_ev, val) => {
                      if (["25.0", "50.0", null].includes(val)) {
                        setField(THIRD_BUYER_ID)(null);
                        toggleBuyer({ selectedThirdBuyer: null });
                      }
                    }}
                    label="Buyer Credit"
                    required
                  />
                </Col>
                <Col md={3}>
                  <BuyerField
                    label={properCase(BUYER)}
                    name={BUYER_ID}
                    searchBuyers={searchBuyers}
                    selectedBuyer={selectedBuyer}
                  />
                </Col>
                <CoBuyersFields
                  buyerCreditPct={getField(BUYER_CREDIT_PCT)}
                  selectedCoBuyer={selectedCoBuyer}
                  selectedThirdBuyer={selectedThirdBuyer}
                  colSize={3}
                  searchBuyers={searchBuyers}
                  toggleBuyer={toggleBuyer}
                  numberOfBuyers={
                    [getField(CO_BUYER_ID), getField(THIRD_BUYER_ID)].filter(
                      s => s
                    ).length + 1
                  }
                />
              </Row>
            </React.Fragment>
          </Authorized>
          <hr className="hr-xs hr-dashed" />
          <TierTypeExchangeSrpWarning
            part={selectedPart}
            srp={getField(SUGGESTED_RETAIL)}
            exchangeSrp={getField(EXCHANGE_SRP)}
          />
          <PreviousSrpConditionWarning
            displayInventory
            partId={selectedPart.id}
            srpCondition={getField(SRP_CONDITION)}
            srp={getField(SUGGESTED_RETAIL)}
            excludeInventoryId={this.props.inventory.get(ID)}
          />
          <Row>
            <Col md={3}>
              <Field
                name={CONDITION}
                component={Select}
                options={toOptions(INVENTORIES.condition)}
                label={properCase(CONDITION)}
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={SRP_CONDITION}
                component={Select}
                options={toOptions(INVENTORIES.condition)}
                label="SRP Condition"
                disabled={disableFields && !hasRole(currentUser, SALES)}
                required
              />
            </Col>
            <Col md={3}>
              <CurrencyField
                name={SUGGESTED_RETAIL}
                label={[
                  "SRP",
                  <AuditedNoteTooltip
                    field={SUGGESTED_RETAIL}
                    obj={inventory.toJS()}
                  />
                ]}
                disabled={disableFields && !hasRole(currentUser, SALES)}
              />
            </Col>
            <Col md={3}>
              <CurrencyField
                name={EXCHANGE_SRP}
                label="Exchange SRP"
                disabled={
                  (disableFields && !hasRole(currentUser, SALES)) ||
                  getField(DO_NOT_EXCHANGE)
                }
                onFocus={this.handlePassFailWarning}
                onBlur={this.handlePassFailWarning}
              />
            </Col>
            {isLLP && [
              <Col md={3}>
                <Field
                  name={TOTAL_HOURS}
                  label="Time Since New (Hours)"
                  component={NumberInput}
                  roundDigits={0}
                  onChange={(_e, val) =>
                    this.props.change(
                      TOTAL_HOURS_REMAINING,
                      totalHoursRemaining(selectedPart, val)
                    )}
                />
              </Col>,
              <Col md={3}>
                <Field
                  name={TOTAL_HOURS_REMAINING}
                  component={NumberInput}
                  roundDigits={0}
                  label={properCase(TOTAL_HOURS_REMAINING)}
                  disabled
                />
              </Col>,
              <Col md={3}>
                <Field
                  name={TOTAL_CYCLES}
                  label="Cycles Since New"
                  component={FormInput}
                  onChange={(_e, val) =>
                    this.props.change(
                      TOTAL_CYCLES_REMAINING,
                      totalCyclesRemaining(selectedPart, val)
                    )}
                />
              </Col>,
              <Col md={3}>
                <Field
                  name={TOTAL_CYCLES_REMAINING}
                  label={properCase(TOTAL_CYCLES_REMAINING)}
                  component={FormInput}
                  disabled
                />
              </Col>
            ]}
          </Row>
          <Row>
            <Col md={6}>
              <Field
                name={TRACE_TYPE}
                component={Select}
                required={getField(TRACED_TO)}
                options={toOptions(INCOMING_LINE_ITEMS.traceTypes)}
                label={properCase(TRACE_TYPE)}
                disabled={disableFields || !canEditTraceAndTagFields}
              />
            </Col>
            <Col md={6}>
              <Field
                name={TRACED_TO}
                component={FormInput}
                label={properCase(TRACED_TO)}
                disabled={disableFields || !canEditTraceAndTagFields}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <MonthYearField
                name={TAG_DATE}
                component={FormInput}
                label={properCase(TAG_DATE)}
                disabled={disableFields || !canEditTraceAndTagFields}
                required={
                  [OVERHAULED, INSPECTED, REPAIRED].includes(condition) &&
                  ![REPAIR_AND_HOLD].includes(selectedRepairStatus)
                }
              />
            </Col>
            <Col md={6}>
              <Field
                name={TAGGED_BY}
                label={properCase(TAGGED_BY)}
                placeholder="Search by a company's name"
                component={AutoCompleteUserInputField}
                search={this.searchCompanies}
                selectedItem={selectedInventory}
                handleTaggedBy={() => null}
                formatItem={result =>
                  (result && result.name) || result.tagged_by}
                disabled={disableFields || !canEditTraceAndTagFields}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Field
                component={FormInput}
                name={AIRCRAFT_REFERENCE_NUMBER}
                label="Aircraft or Engine Ref # (MSN,ESN,etc.)"
              />
            </Col>
            <Col md={6}>
              <Field
                component={FormInput}
                name={AIRCRAFT_TAIL_NUMBER}
                label="Aircraft Tail #"
              />
            </Col>
          </Row>
          <FormRow>
            <Col md={4}>
              <MonthYearField
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
                name="dom"
                component={FormInput}
                label="DOM"
              />
            </Col>
            <Col md={4}>
              <Field
                component={FormInput}
                name={EXPIRATION}
                type="date"
                label="exp"
                disabled={
                  disableFields ||
                  (!isAdminUser &&
                    !isNonBasicWarehouseUser &&
                    !isRepairUser &&
                    !isQCUser)
                }
              />
            </Col>
            <Col md={4}>
              <CheckGroup justified title={properCase(FINAL_FREIGHT_CONFIRMED)}>
                <Field
                  name={FREIGHT_COMPLETE}
                  component={Check}
                  label={properCase(FREIGHT_COMPLETE)}
                  disabled={!canEditFreightComplete}
                />
              </CheckGroup>
            </Col>
          </FormRow>
          <FormRow>
            <Col md={getField(IMPERFECT_TRACE) ? 9 : 12}>
              <CheckGroup justified title="Flags">
                <Field
                  name={IMPERFECT_TRACE}
                  component={Check}
                  label={properCase(IMPERFECT_TRACE)}
                  disabled={!canEditFlags}
                />
                <Field
                  name="der"
                  component={Check}
                  label="DER"
                  disabled={!canEditFlags}
                />
                <Field
                  name="pma"
                  component={Check}
                  label="PMA"
                  disabled={!canEditFlags}
                />
                <Field
                  name="modified"
                  component={Check}
                  label="Modified"
                  disabled={!canEditFlags}
                />
                <Field
                  name={INCIDENT}
                  component={Check}
                  label={properCase(INCIDENT)}
                  disabled={!canEditFlags}
                />
              </CheckGroup>
            </Col>
            {getField(IMPERFECT_TRACE) && (
              <Col md={3}>
                <Field
                  name={IMPERFECT_TRACE_REASON}
                  component={Select}
                  options={toOptions(IMPERFECT_TRACE_REASONS)}
                  label={"Imperfect Trace Reason"}
                  disabled={disableFields || !canEditTraceAndTagFields}
                />
              </Col>
            )}
          </FormRow>
          <FormRow>
            <Col md={12}>
              <Fields
                names={[FAA, EASA, CAAC, TCCA, OTHER, UK_CAA, OTHER_TAG_TYPE]}
                component={TagTypes}
                formName={FORM_NAME}
                disabled={
                  !(
                    isAdminUser ||
                    isNonBasicWarehouseUser ||
                    isRepairUser ||
                    isQCUser
                  )
                }
              />
            </Col>
          </FormRow>
          <hr className="hr-xs hr-dashed" />
          <FormRow>
            <Col md={4}>
              <CheckGroup justified title="SN Re-identification Reqd">
                <Field
                  name="serial_number_correction_required"
                  component={Check}
                  label="SN Re-identification Reqd"
                  disabled={!canReidentifySerial}
                />
              </CheckGroup>
            </Col>
            <Col md={3}>
              <Field
                component={FormInput}
                name="correct_serial_number"
                label="Correct SN (appears to be)"
                disabled={!canReidentifySerial}
              />
            </Col>
          </FormRow>
          <hr className="hr-xs hr-dashed" />
          <Row>
            <Col md={3}>
              <Field
                name={LISTING_OVERRIDE}
                component={Select}
                onChange={(ev, val) => {
                  if (isEmpty(val)) {
                    ev.preventDefault();
                    setField(LISTING_OVERRIDE)(null);
                  }
                }}
                onBlur={ev => ev.preventDefault()}
                options={toOptions(INVENTORIES.listing_override)}
                label={properCase(LISTING_OVERRIDE)}
                disabled={!canOverrideListing}
              />
            </Col>
            <Col md={3}>
              <CheckGroup title="Do Not Exchange" justified>
                <Field
                  name={DO_NOT_EXCHANGE}
                  component={Check}
                  label={properCase(DO_NOT_EXCHANGE)}
                  disabled={
                    !hasPermission(currentUser, CAN_EDIT_DO_NOT_EXCHANGE)
                  }
                  onChange={(_ev, val) => {
                    if (val) setField(EXCHANGE_SRP)(null);
                  }}
                />
              </CheckGroup>
            </Col>
            <Col md={3}>
              <CheckGroup title="Do Not Sell!" justified>
                <Field
                  name={UNSELLABLE_PER_USER}
                  component={props => <Check {...props} icon="fa-diamond" />}
                  disabled={disableIfHasAnyOfRoles(currentUser, [WAREHOUSE])}
                  label="Do Not Sell!"
                />
              </CheckGroup>
            </Col>
            {getField(UNSELLABLE_PER_USER) && (
              <Col md={3}>
                <Field
                  name={DO_NOT_SELL_REASON}
                  label="Reason for Do Not Sell?"
                  component={Select}
                  options={DO_NOT_SELL_REASON_OPTIONS}
                  required
                />
              </Col>
            )}
          </Row>
          <hr className="hr-xs hr-dashed" />
          <FormRow>
            <Col md={6}>
              <Field
                component={Select}
                options={arrayToOptions(WARRANTY_OPTIONS)}
                name={WARRANTY_OVERRIDE}
                label={properCase(WARRANTY_OVERRIDE)}
                disabled={currentUser.role !== ADMIN}
              />
            </Col>
          </FormRow>
          <hr className="hr-xs hr-dashed" />
          <Row>
            <Col md={6}>
              <Field
                name={CONSIGNMENT_REFERENCE}
                component={FormInput}
                label="Consignment #"
                disabled={!hasSubRole(currentUser, QUALITY_CONTROL_MANAGER)}
              />
            </Col>
            <Col md={6}>
              <Field
                name={CONSIGNOR_PERCENTAGE}
                component={FormInput}
                label="Consignment Split"
                disabled
              />
            </Col>
          </Row>
          <ConditionWarning
            inventoryCondition={inventory.get(CONDITION)}
            condition={getField(CONDITION)}
            canClose={false}
          />
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  getField: PropTypes.func.isRequired,
  searchParts: PropTypes.func.isRequired,
  inventory: PropTypes.shape({ toJS: PropTypes.func }),
  quantity: PropTypes.number,
  condition: PropTypes.string,
  lockInventory: PropTypes.bool,
  searchBuyers: PropTypes.func.isRequired
};

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    currentUser: state.session.get(USER).toJS(),
    id: state.partDetail.getIn([PART, ID]),
    quantity: selector(state, QUANTITY),
    condition: selector(state, CONDITION),
    reserveForSellerId: selector(state, RESERVE_FOR_SELLER_ID),
    getField: field => selector(state, field),
    minExchangeSrp: state.session.getIn([SETTINGS, MINIMUM_EXCHANGE_SRP])
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.update(data)),
    searchParts: filter => dispatch(partsActions.searchParts(filter)),
    searchBuyers: filter => dispatch(poActions.searchBuyers(filter)),
    setField: field => val => dispatch(change(FORM_NAME, field, val))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/EditInventory/Form.jsx